import paymentUpdateRoutes from './modules/update/routes'

export default paymentUpdateRoutes
